module.exports = __webpack_public_path__ + "img/img3.f3e34eb3.jpg";